module.exports = __webpack_public_path__ + "static/media/spades_5.60969bb1.png";